/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ drop: NonNullable<unknown>, keep: NonNullable<unknown> }} Vekn_Merge_SummaryInputs */



/**
* | output |
* | --- |
* | "{drop} will be deleted, and their login methods, sanctions and data transferred to {keep}." |
*
* @param {Vekn_Merge_SummaryInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_merge_summary = /** @type {((inputs: Vekn_Merge_SummaryInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Merge_SummaryInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.drop} sera supprimé, et ses méthodes de connexion, sanctions et données seront transférées vers ${i?.keep}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.drop} será eliminado, y sus métodos de inicio de sesión, sanciones y datos se transferirán a ${i?.keep}.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.drop} será excluído, e seus métodos de login, sanções e dados serão transferidos para ${i?.keep}.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.drop} verrà eliminato, e i suoi metodi di accesso, sanzioni e dati verranno trasferiti a ${i?.keep}.`)
	return /** @type {LocalizedString} */ (`${i?.drop} will be deleted, and their login methods, sanctions and data transferred to ${i?.keep}.`)
});